import React from "react";
import PropTypes from "prop-types";

//
import { Card, Col } from "react-bootstrap";

//
import BoxLoading from "../general/BoxLoading";

function StatisticsItem({ title, subject, text, loading, icon }) {
  return (
    <Col sm={6} xxl={3} className="gutter-b">
      <Card className="h-100">
        <img src={process.env.PUBLIC_URL + `/icons/${icon}.svg`} alt="icon" />
        <p className="title">{title}</p>
        <h4>{subject}</h4>
        <small className="mt-auto">{text}</small>
        {loading && <BoxLoading />}
      </Card>
    </Col>
  );
}

StatisticsItem.propTypes = {
  title: PropTypes.string.isRequired,
  subject: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  icon: PropTypes.string.isRequired,
};

export default StatisticsItem;
